import React from "react";
import CardView from "../../../../components/common/CardView";
import BaseListPage from "../../../../base/BaseListPage";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../usecases/object";
import { FloatingForm } from "../../../../components/common/Converter";
import { Timeline } from "antd";
import withRouter from "../../../../withRouter";
import MainpageNoticePresenter from "./MainpageNoticePresenter";

class MainpageNotice extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new MainpageNoticePresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = {
      progress: false,
      objects: [],
      notices: [],
      recentAct: [],
      isReading: false,
      isReadData: {},
      showRecent: false,
    };
  }

  async componentDidMount() {
    this.presenter.componentDidMount();
  }

  showProgress() {
    this.setState({ progress: true });
  }

  hideProgress() {
    this.setState({ progress: false });
  }

  getCollectionName() {
    return "notices";
  }

  handleViewMoreAct() {
    this.navigateTo(`/app/activities`);
  }
  render() {
    return (
      <>
        <div className="w-100 row d-flex flex-grow-1 p-0 h-100">
          <div className="col-lg-6 mb-2 d-flex h-50">
            <CardView>
              <h4 className="text-primary fw-bolder pt-2 pb-2">
                Recent Activities
              </h4>
              <div style={{ border: "1px solid #d3d3d3" }} />
              {this.state.recentAct.length > 0 ? (
                <>
                  <div
                    style={{
                      overflow: "hidden",
                      height: "25rem",
                      marginTop: "1rem",
                    }}
                  >
                    <Timeline
                      items={this.state.recentAct.map((item) => ({
                        children: (
                          <div
                            className="d-grid fs-6 mt-1"
                            style={{ color: "rgba(0, 0, 0, .45)" }}
                          >
                            <span className="fw-semibold text-dark">
                              {item.activity}
                            </span>
                            <label className="fs-sm">{item.logDate}</label>
                            <label className="fs-sm">{item.message}</label>
                          </div>
                        ),
                      }))}
                    />
                  </div>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      height: "100%",
                    }}
                  >
                    <button
                      onClick={this.handleViewMoreAct.bind(this)}
                      className="text-primary bg-transparent mt-auto border-0 fs-6"
                    >
                      View more
                    </button>
                  </div>
                </>
              ) : (
                <div
                  style={{
                    overflow: "hidden",
                    minHeight: "25rem",
                  }}
                ></div>
              )}
            </CardView>
          </div>

          {/* Notice Board */}
          <div className="col-lg-6 mb-2 d-flex h-25">
            <CardView>
              <h4 className="text-primary fw-bolder pt-2 pb-2">Notice Board</h4>
              <div style={{ border: "1px solid #d3d3d3" }} />
              <div
                style={{
                  overflowY: "scroll",
                  overflowX: "hidden",
                  maxHeight: "20rem",
                }}
              >
                <div className="p-2">
                  <div className="row">
                    {this.state.notices.length > 0 ? (
                      <>
                        <div className="d-grid gap-3 pt-2">
                          {this.state.notices.map((item) => {
                            const formattedDate = new Date(
                              item.createdAt
                            ).toLocaleDateString("en-US", {
                              year: "numeric",
                              month: "long",
                              day: "numeric",
                            });
                            return (
                              <>
                                <div
                                  className="d-flex align-items-center border rounded-1 p-2 gap-2"
                                  key={item}
                                >
                                  <i
                                    className="bi bi-bell-fill text-primary"
                                    style={{ zoom: 1.4 }}
                                  />
                                  <div
                                    className="d-grid fs-6"
                                    style={{ color: "rgba(0, 0, 0, .45)" }}
                                  >
                                    <label className="fw-semibold text-dark">
                                      {item.title.toUpperCase()}
                                    </label>
                                    <label className="fs-sm">
                                      {formattedDate}
                                    </label>
                                  </div>
                                  <button
                                    onClick={() =>
                                      this.setState({
                                        isReading: true,
                                        isReadData: item,
                                      })
                                    }
                                    className="btn btn-white border-primary text-primary ms-auto"
                                  >
                                    <i className="bi bi-book" /> Read
                                  </button>
                                </div>
                              </>
                            );
                          })}
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="d-flex align-items-center justify-content-center pt-2">
                          <img width="120" src={"/noData.svg"} alt="No Data" />
                        </div>
                        <p className="text-center">No Data</p>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </CardView>
          </div>
          {/* read Notice  */}
          {this.state.isReading && (
            <FloatingForm width="50rem">
              <CardView>
                <label className="fs-6 fw-semibold m-1">
                  {this.state.isReadData.title.toUpperCase()}
                </label>
                <div className="d-grid border rounded-1 p-2 gap-2 overflow-auto">
                  <label
                    className="fs-sm "
                    dangerouslySetInnerHTML={{
                      __html: `${this.state.isReadData.description}`,
                    }}
                  />
                </div>
                <div className="mt-3">
                  {Array.isArray(this.state.isReadData.selectedFiles) &&
                    this.state.isReadData.selectedFiles.length > 0 &&
                    this.state.isReadData.selectedFiles.map((item) => {
                      const fullFilename = item.split("/").pop();
                      const filename = fullFilename.substring(
                        fullFilename.indexOf("_") + 1
                      );
                      return (
                        <p>
                          <a
                            href={item}
                            download={filename.replaceAll("_", " ")}
                          >
                            {filename.replaceAll("_", " ")}
                          </a>
                        </p>
                      );
                    })}
                </div>
                <button
                  onClick={() =>
                    this.setState({ isReading: false, isReadData: {} })
                  }
                  className="btn btn-primary m-2 ms-auto"
                >
                  Close
                </button>
              </CardView>
            </FloatingForm>
          )}
        </div>
        {/* </div> */}
      </>
    );
  }
}

export default withRouter(MainpageNotice);
